<template>
  <div slot="header">
    <el-badge v-if="!!imagenes_banner.length && mostrarBoton"
              :value="imagenes_banner.length"
              class="item mr-3"
    >
      <el-button size="small"
                 @click="establecerModalBanner(true)"
                 v-text="texto"
      />
    </el-badge>
  </div>

</template>

<script>
import {mapMutations, mapState} from "vuex";
import {getAcls} from "../plugins/acl";

export default {
  name: 'DefaultHeaderDropdown',
  data() {
    return {
      texto: '',
      empresa: null
    };
  },
  mounted() {
    const acls = getAcls();

   if (acls.info_empresa) {
      this.empresa = acls.info_empresa;

      this.texto = this.empresa.boton_banner;
   }
  },
  computed: {
    ...mapState('banners', ['imagenes_banner']),
    mostrarBoton() {
      return this.empresa && this.empresa.banner && this.imagenes_banner.some(i => i.id_empresa === this.empresa.id);
    }
  },
  methods: {
    ...mapMutations('banners', ['establecerModalBanner'])
  }
};
</script>

